import { ErrorTypesErrorResponseDTO } from "./autogenerated";

export class ApiResponse<T> {
  constructor(public success: boolean, public value: T | undefined, public error: ErrorTypesErrorResponseDTO | undefined) { }
}
